import { useMutation, useQuery } from '@tanstack/react-query';
import { createRuleGroup, deleteRuleGroup, getRuleGroups, getRuleFields, restoreRuleGroup, updateRuleGroup } from '@/features/agreements/services/ruleGroupsService';

const BASE = 'rule-groups';

export const ruleGroupsQueryKeys = {
  base: () => [BASE],
  list: (data) => (data ? [BASE, 'list', data] : [BASE, 'list']),
  ruleFields: () => [BASE, 'rule-fields'],
};

export const useGetRuleGroups = (data, { enabled = true } = {}) => {
  return useQuery({
    queryKey: ruleGroupsQueryKeys.list(data),
    queryFn: () => getRuleGroups(data),
    enabled,
  });
};

export const useGetRuleFields = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ruleGroupsQueryKeys.ruleFields(),
    queryFn: getRuleFields,
    enabled,
  });
};

export const useCreateRuleGroup = () => {
  return useMutation({
    mutationFn: ({ data }) => createRuleGroup(data),
  });
};

export const useUpdateRuleGroup = () => {
  return useMutation({
    mutationFn: ({ id, data }) => updateRuleGroup(id, data),
  });
};

export const useDeleteRuleGroup = () => {
  return useMutation({
    mutationFn: ({ id }) => deleteRuleGroup(id),
  });
};

export const useRestoreRuleGroup = () => {
  return useMutation({
    mutationFn: ({ id }) => restoreRuleGroup(id),
  });
};
